import { Img, Picture } from '@xo-union/tk-component-picture';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { awardsInfo } from '../../../../../utils/awardsInfo';

const CARD_IMG_HEIGHT = 500;
const CARD_IMG_WIDTH = 500;
const pixelDensities = [1]; // override picture component creation of 1.5x and 2x densities

/** @internal */
export class Icon extends PureComponent {
	static propTypes = {
		awardType: PropTypes.object.isRequired,
	};

	render() {
		const { awardType } = this.props;
		const { bow, hof } = awardsInfo();

		let imageId = bow.iconId;
		let alt = 'best of weddings';
		if (awardType.slug !== bow.slug) {
			imageId = hof.iconId;
			alt = hof.name;
		}

		return (
			<React.Fragment>
				<Picture env="production" id={imageId} pixelDensities={pixelDensities}>
					<Img
						alt={alt}
						height={CARD_IMG_HEIGHT}
						width={CARD_IMG_WIDTH}
						smartCrop
					/>
				</Picture>
			</React.Fragment>
		);
	}
}

function mapStateToProps(state) {
	return {
		awardType: state.bow.awardType,
	};
}

export default connect(mapStateToProps)(Icon);
